export default __webpack_public_path__ + "static/slide_2-a532fdc312c19a8aa142be4c7d991258.png";